<div class="modal-body content width-500 ">
	<div class="layout-auto-1-auto">
    <span class="modal-header">
      {{data.modalHeader}}
    </span>
		<div class="content layout-auto-1">
			<p>
				{{data.changeStateText}}
			</p>
			<exg-textarea [(ngModel)]="data.reviewClone.rcptCommentNext"
			              [caption]="'Bearbeitungshinweis'"
			              [required]="data.forceComment
			                && !(data.reviewClone.rcptCommentNext && data.reviewClone.rcptCommentNext.length > 0)"
			              [hintText]="hintText"
			              *ngIf="data.forceComment"
			              [maxlength]="5000"
                    #VCCommentNext>
			</exg-textarea>
			<div class="spawn-reverse app-textcount"
			     *ngIf="data.forceComment">
				<span style="top: -2.75rem">(Zeichen: {{data.reviewClone.rcptCommentNext.length}}{{' | ' + 5000}})</span>
			</div>
		</div>
		<div class="spawn-modal-actions typo-small">
			<button (click)="cancel()" class="md-btn">
				{{getGlobal('Cancel')}}
			</button>
			<button (click)="save()"
			        [class.disabled]="data.forceComment && !(data.reviewClone.rcptCommentNext && data.reviewClone.rcptCommentNext.length > 0)"
			        class="md-btn">
				{{data.btnText}}
			</button>
		</div>
	</div>
</div>
